export default __webpack_public_path__ + "static/media/G0460-PE-algorithm.1711031940000.bad92c47.jpg";